import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

// Create a baseQuery with auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/seatAvailability`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken(); // Get token from cookies or storage
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Wrap the baseQuery with retry logic
const baseQueryWithRetry = retry(baseQuery, { maxRetries: 3 });

export const seatAvailabilitySlice = createApi({
  reducerPath: "seatAvailabilitySlice",
  baseQuery: baseQueryWithRetry,
  tagTypes: ["SeatAvailability"],
  endpoints: (builder) => ({
    // GET SeatAvailability List
    getSeatAvailability: builder.query({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();

        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search) params.append("search", search);

        const queryString = params.toString();
        return queryString ? `?${queryString}` : "";
      },
      providesTags: ["SeatAvailability"],
    }),
    getSeatAvailabilityDetails: builder.query({
      query: (id) => `${id}`,
      providesTags: ["SeatAvailability"],
    }),
    // Create SeatAvailability
    createSeatAvailability: builder.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["SeatAvailability"],
    }),
    // Update Seat Availability
    updateSeatAvailability: builder.mutation({
      query: ({ data, id }) => ({
        url: `${id}`,
        method: "Put",
        body: data,
      }),
      invalidatesTags: ["SeatAvailability"],
    }),
    // DELETE a Seat Availability
    deleteSeatAvailability: builder.mutation({
      query: (id) => ({
        url: `${id}`,
        method: "Delete",
      }),
      invalidatesTags: ["SeatAvailability"],
    }),
  }),
});

export const {
  useGetSeatAvailabilityQuery,
  useGetSeatAvailabilityDetailsQuery,
  useCreateSeatAvailabilityMutation,
  useUpdateSeatAvailabilityMutation,
  useDeleteSeatAvailabilityMutation,
} = seatAvailabilitySlice;
